import React from 'react';
import './HomeHeader.css';

const HomeHeader = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      {/* <div className='Heading'>
        <span>
          <img
            src='./assets/filterMenu.png'
            alt='homeheader-img'
            className='filter-icon'
          />
        </span>
        <span className='filter-text'>Filter by Date</span>
      </div> */}
    </div>
  );
};

export default HomeHeader;
